import { Badge, Button, FloatingPosition, MantineSize, Tooltip } from '@mantine/core';
import { IconType } from 'react-icons';

interface PortalButtonProps {
  label?: string;
  Icon?: IconType;
  onClick?: () => void;
  variant?: 'outline' | 'filled' | 'subtle' | 'light' | 'default';
  fullWidth?: boolean;
  color?: string;
  tooltip?: {
    label: string;
    position?: FloatingPosition;
  };
  type?: 'submit';
  loading?: boolean;
  disabled?: boolean;
  size?: MantineSize;
  badgeNumber?: number;
  badgeNumberLimit?: number;
  testId?: string;
}

export const PortalButton = ({
  label,
  Icon,
  onClick,
  variant = 'filled',
  fullWidth = false,
  color,
  tooltip,
  type,
  loading = false,
  disabled = false,
  size,
  badgeNumber,
  badgeNumberLimit,
  testId,
}: PortalButtonProps) => {
  let icon;
  if (Icon) {
    icon = <Icon size={14} />;
  }

  const badgeNumberPostfix = badgeNumberLimit !== undefined ? `/${badgeNumberLimit}` : '';

  return (
    <Tooltip disabled={tooltip === undefined} label={tooltip?.label} position={tooltip?.position}>
      <Button
        type={type}
        onClick={onClick}
        leftSection={label && icon}
        variant={variant}
        fullWidth={fullWidth}
        color={color}
        loading={loading}
        disabled={disabled}
        size={size}
        data-testid={testId}
      >
        {label || icon}
        {badgeNumber && (
          <Badge
            ml={10}
            variant={'outline'}
            color={variant === 'filled' ? 'var(--mantine-color-white)' : 'var(--mantine-primary-color-filled)'}
            style={{ cursor: 'inherit' }}
          >
            {badgeNumber}
            {badgeNumberPostfix}
          </Badge>
        )}
      </Button>
    </Tooltip>
  );
};
